import Amplify, { Auth } from 'aws-amplify'

export const OPT_OUT_TOKEN = 'optOutToken'

export const getAuthorizationToken = async () => {
  const schedulerToken = localStorage.getItem(OPT_OUT_TOKEN)
  if (schedulerToken) {
    return `scheduler:${schedulerToken}`
  } else {
    const session = await Auth.currentSession()
    return session.getIdToken().getJwtToken()
  }
}

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
    authenticationFlowType: process.env.REACT_APP_COGNITO_AUTH_FLOW,
    mandatorySignIn: true,
  },
  API: {
    endpoints: [
      {
        name: 'civicChampsApi',
        endpoint: process.env.REACT_APP_API_ENDPOINT,
        custom_header: async () => ({ Authorization: await getAuthorizationToken() }),
      },
      {
        name: 'civicChampsPublicApi',
        endpoint: process.env.REACT_APP_API_ENDPOINT,
        custom_header: async () => ({}),
      },
    ],
  },
})

// Auth.signOut()
